import React from 'react';
import { Gift, Eye, Users } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';

export const OfferStatsCards = ({ offers, clients }) => {
    const cards = [
        { label: 'Total offres', value: offers.length, icon: Gift, bg: 'bg-purple-100', iconColor: 'text-purple-600' },
        { label: 'Offres actives', value: offers.filter(o => o.is_active).length, icon: Eye, bg: 'bg-green-100', iconColor: 'text-green-600' },
        { label: 'Clients disponibles', value: clients.length, icon: Users, bg: 'bg-blue-100', iconColor: 'text-blue-600' },
    ];

    return (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            {cards.map(({ label, value, icon: Icon, bg, iconColor }) => (
                <Card key={label}>
                    <CardContent className="pt-6">
                        <div className="flex items-center gap-4">
                            <div className={`p-3 ${bg} rounded-xl`}>
                                <Icon className={`h-6 w-6 ${iconColor}`} />
                            </div>
                            <div>
                                <p className="text-2xl font-bold">{value}</p>
                                <p className="text-sm text-muted-foreground">{label}</p>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
};
